<template>
  <div class="role-per-bd ubv">
    <div class="ub-f1 ubv">
      <div class="ub ub-sp" style="padding: 22px 0 14px">
        <el-radio-group v-model="appId" @change="onAppItem">
          <el-radio-button v-for="(item, index) in appList" :key="index" :label="item.appId">{{ item.appName }}</el-radio-button>
        </el-radio-group>
        <template v-if="funcView.role_permission_save">
          <el-button :disabled="!roleId || disabled" v-if="type === 'page'" type="warning" @click="saveRolePer">
            <i class="icon icon-shiliang1"></i>
            <span>&ensp;{{ $t('com_save') }}</span>
          </el-button>
        </template>
      </div>
      <div class="ub-f1 per-wrap">
        <custom-table stripe v-loading="isLoading" tableCode="portal_roleAuth" :defaultExpandAll="true" row-key="menuId" :data="appMenu" height="100%" :slots="['menuFunList', 'menuFunListHeader']">
          <template slot="menuFunListHeader" slot-scope="scope">
            <el-checkbox :disabled="!roleId || disabled" v-model="isCheckAll" :indeterminate="!!indeterminate" @change="onCheckAll">
              <span style="font-weight: bold">{{ scope.column.label }}</span>
            </el-checkbox>
          </template>
          <template slot="menuFunList" slot-scope="scope">
            <div class="ub">
              <div class="checkall" v-if="scope.row.funList.length">
                <el-checkbox :indeterminate="!!scope.row.indeterminate" :disabled="!roleId || disabled" v-model="scope.row.checkedAll" @change="checkAllChange($event, scope.row.funList, scope.row)">
                  {{ $t('com_sel_all') }}
                </el-checkbox>
              </div>
              <div class="ub-f1 func-list-box">
                <div class="ub" v-for="(arr, name) in onFuncListGroup(scope.row.funList)" :key="name">
                  <div class="checkall" v-if="name != 'default'" style="margin-right: 12px; color: #b3b3b3">
                    {{ name }}
                  </div>
                  <div class="ub-f1" style="flex-wrap: wrap; display: flex">
                    <el-checkbox :disabled="!roleId || disabled" @change="checkChange($event, scope.row)" v-for="item in arr" :key="item.funcId" v-model="item.checked">
                      {{ item.funcShortName || item.funcName }}
                    </el-checkbox>
                  </div>
                </div>
              </div>
              <!-- <div class="ub-f1" style="flex-wrap: wrap; display: flex;">
                <el-checkbox :disabled="!roleId" @change="checkChange($event, scope.row)" v-for="item in scope.row.funList" :key="item.funcId" v-model="item.checked">{{ item.funcName }}</el-checkbox>
              </div> -->
            </div>
          </template>
        </custom-table>
      </div>
    </div>
  </div>
</template>
<script>
import apis from '@/utils/apis';



export default {
  props: {
    type: {
      type: String,
      default: 'page',
    },
    roleId: {
      type: [String, Number],
      default: '',
    },
    disabled: Boolean
  },
  data() {
    return {
      appId: '',
      appList: [],
      appMenuTree: [], // 未赋值
      appMenuCache: {},
      appMenu: [], // 赋值后
      isLoading: false,
      isCheckAll: false,
      indeterminate: false,
    };
  },

  watch: {
    roleId: function () {
      this.appMenu = [];
      this.getAppMenu();
    },
  },
  mounted() {
    this.getAppList();
    this.getFuncView();
  },
  methods: {
    onFuncListGroup: function (list) {
      let obj = {};
      const arr = [];
      const reg = /.*?(?=\s\-)/;
      if (list && list.length) {
        list.forEach((item) => {
          const str = item.funcName || '';
          const groupKey = str.match(reg) && str.match(reg)[0];
          if (groupKey) {
            this.$set(item, 'funcShortName', str.replace(`${groupKey} - `, ''));
            if (obj[groupKey]) {
              obj[groupKey].push(item);
            } else {
              obj[groupKey] = [item];
            }
          } else {
            arr.push(item);
          }
        });
      }
      if (arr.length) {
        obj = Object.assign({}, obj, { default: arr });
      }
      return obj;
    },
    // 获取应用列表
    getAppList: function () {
      this.$getJSON(apis.AppList).then((res) => {
        this.appList = res.data.filter(t => ['portal', 'customer-portal', 'custom_app'].includes(t.appCode));
        const app = this.appList[0] ? this.appList[0] : {};
        this.appId = app.appId;
        this.getAppMenu();
      });
    },
    // 选择应用
    onAppItem: function (item) {
      this.appId = item;
      this.getAppMenu();
    },
    // 获取应用菜单树
    getAppMenu: function () {
      const appId = JSON.parse(JSON.stringify(this.appId)); // 不能直接使用this.appId,因为这个值可能中途修改导致赋值错误
      if (!appId) {
        return;
      }
      if (this.appMenuCache[appId]) {
        this.appMenuTree = this.appMenuCache[appId];
        this.getRolePerList();
        return;
      }
      this.isLoading = true;
      this.$getJSON(`${apis.AppMenuTree}/${appId}`).then((res) => {
        this.isLoading = false;
        this.appMenuCache[appId] = res.data || []; // 缓存
        if (appId === this.appId) {
          // 未切换appId时赋值
          this.appMenuTree = res.data || [];
          this.getRolePerList();
        }
      });
    },
    // 获取角色权限
    getRolePerList: function () {
      if (!this.roleId || !this.appId) {
        this.mergeTree([]);
        return;
      }
      this.isLoading = true;
      this.$getJSON(apis.menuFunc, {
        roleId: this.roleId,
        appId: this.appId,
      }).then((res) => {
        this.isLoading = false;
        const list = res.data;
        this.mergeTree(list);
        this.computedAll();
      });
    },
    // 设置岗位选中状态
    mergeTree: function (list) {
      const tree = JSON.parse(JSON.stringify(this.appMenuTree));
      tree.forEach((item) => {
        if (item.children && item.children.length) {
          item.children.forEach((items) => {
            items.funList.forEach((value1) => {
              value1.checked = !!list.includes(value1.menuFuncId);
            });
            const len = items.funList.filter(t => t.checked).length;
            items.checkedAll = items.funList.length === len;
            items.indeterminate = !items.checkedAll && len;
          });
        } else {
          item.funList.forEach((value) => {
            value.checked = !!list.includes(value.menuFuncId);
          });
          const len = item.funList.filter(t => t.checked).length;
          item.checkedAll = item.funList.length === len;
          item.indeterminate = !item.checkedAll && len;
        }
      });
      this.appMenu = tree;
    },
    // 全局全选事件
    onCheckAll: function (val) {
      this.indeterminate = false;
      if (!val) {
        this.mergeTree([]);
        return;
      }
      const funcIds = this.getAllFuncId();
      this.mergeTree(funcIds);
    },
    // 获取选中funcId
    getCheckedFuncId: function () {
      let list = [];
      this.appMenu.forEach((item) => {
        if (item.children && item.children.length) {
          item.children.forEach((value) => {
            const checkeds = value.funList.filter(t => t.checked);
            list = [...list, ...checkeds];
          });
        } else {
          const checkeds = item.funList.filter(t => t.checked);
          list = [...list, ...checkeds];
        }
      });
      list = list.map(t => t.menuFuncId);
      return list;
    },
    // 获取全部funcId
    getAllFuncId: function () {
      let list = [];
      this.appMenu.forEach((item) => {
        if (item.children && item.children.length) {
          item.children.forEach((value) => {
            const checkeds = value.funList;
            list = [...list, ...checkeds];
          });
        } else {
          const checkeds = item.funList;
          list = [...list, ...checkeds];
        }
      });
      list = list.map(t => t.menuFuncId);
      return list;
    },
    // 计算全局全选
    computedAll: function () {
      const funcIds = this.getAllFuncId();
      const list = this.getCheckedFuncId();
      this.isCheckAll = list.length === funcIds.length;
      this.indeterminate = list.length && list.length !== funcIds.length;
    },
    // 局部全选事件
    checkAllChange: function (value, list, row) {
      list.forEach((item) => {
        item.checked = value;
      });
      row.indeterminate = false;
      this.computedAll();
    },
    // 权限单选事件
    checkChange: function (value, row) {
      const len = row.funList.filter(t => t.checked).length;
      row.checkedAll = row.funList.length === len;
      row.indeterminate = !row.checkedAll && len;
      this.computedAll();
    },
    // 保存权限
    saveRolePer: function () {
      const menuFuncId = this.getCheckedFuncId();
      const params = {
        appId: this.appId,
        roleId: this.roleId,
        menuFuncId: menuFuncId,
      };
      this.$postJSON(apis.RoleFun, params, true).then(() => {
        this.$message({
          message: this.$t('com_handle_success'),
          type: 'success',
        });
        this.$emit('success');
      });
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.role-per-bd {
  .per-wrap {
    padding: 0 0 24px;
    overflow: hidden;
    .el-table--medium td {
      padding: 11px 0 9px 0;
    }
    .el-table__header-wrapper .cell {
      font-size: 14px;
    }
    .cell {
      font-size: 14px;
      color: $--color-text-regular;
    }
    .el-checkbox__label {
      color: $--color-text-regular;
      line-height: 24px;
      font-weight: normal;
      font-size: 14px;
    }
    .checkall {
      display: flex;
      align-items: center;
      padding-right: 15px;
      margin-right: 15px;
      position: relative;
      min-width: 140px;
      &::before {
        content: '';
        position: absolute;
        right: 0;
        top: 2px;
        bottom: 2px;
        width: 1px;
        background-color: #e4e4e4;
      }
    }
    .func-list-box {
      & > div {
        padding-bottom: 5px;
        margin-bottom: 5px;
        border-bottom: 1px dotted #e6e6e6;
        &:last-child {
          padding-bottom: 0;
          margin-bottom: 0;
          border-bottom: none;
        }
      }
    }
  }
}
</style>
